export default "__VITE_PUBLIC_ASSET__8e058a3f__"